import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import messages_en from "./translations/en.json";
import messages_pt from "./translations/pt.json";
import messages_fr from "./translations/fr.json";

const messages = {
    en: messages_en,
    pt: messages_pt,
    fr: messages_fr,
};

const CustomerDetails = ({ customer }) => {
    const locale = localStorage.getItem("language");

    // Group configurations for conditional rendering
    const groups = [
        {
            id: "contactInfo",
            title: "client.general_info",
            fields: [
                {
                    label: "client.customer_type",
                    value: customer.client_level_1,
                },
                { label: "client.address", value: customer.address_1 },
                { label: "client.zip_code", value: customer.zip_code },
                { label: "client.city", value: customer.city },
                { label: "client.season_start", value: customer.season_start },
                { label: "client.season_end", value: customer.season_end },
                // { label: "client.is_seasonal", value: customer.is_seasonal },
            ],
        },
        {
            id: "addressContact",
            title: "client.contact_info",
            fields: [
                {
                    label: "client.contact_name",
                    value: customer.purchasing_manager,
                },
                { label: "client.contact_number", value: customer.phone },
                { label: "client.mail", value: customer.mail },
                { label: "client.website", value: customer.website_url },
            ],
        },
    ];

    return (
        customer && (
            <IntlProvider locale={locale} messages={messages[locale]}>
                <div className="mt-2 text-black flex-col w-full">
                    {groups.map((group) => {
                        // Only render the group if it has fields
                        const hasFields = group.fields.some(
                            (field) => field.value
                        );
                        return (
                            hasFields && (
                                <div
                                    className=" ml-4 text-left mb-10"
                                    key={group.id}
                                >
                                    <div className="flex flex-row items-center w-full pb-3">
                                        <h1 className="w-full font text-md text-black font-bold">
                                            <FormattedMessage
                                                id={group.title}
                                            />
                                        </h1>
                                    </div>
                                    <div className="flex flex-col w-full">
                                        {group.fields.map((field, index) => (
                                            <div
                                                className="mr-2 text-sm flex flex-row w-full mt-1"
                                                style={{
                                                    minWidth: 120,
                                                }}
                                                key={index}
                                            >
                                                <div className="flex font-semibold w-1/2">
                                                    <FormattedMessage
                                                        id={field.label}
                                                    />
                                                    {":"}
                                                </div>
                                                <div
                                                    className="flex w-1/2"
                                                    style={field.style}
                                                >
                                                    {field.value &&
                                                    field.value.startsWith(
                                                        "https"
                                                    ) ? (
                                                        <a
                                                            href={field.value}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-500 underline"
                                                        >
                                                            Lien
                                                        </a>
                                                    ) : (
                                                        field.value
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        );
                    })}
                </div>
            </IntlProvider>
        )
    );
};

export default CustomerDetails;
